module.exports = __webpack_public_path__ + "img/risk_img_cashier@3x.bd2c5d84.png";